module.exports = __webpack_public_path__ + "img/14.bdf399ee.png";